'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var RsqlQueryService = function RsqlQueryService(momentService) {
  var operatorsByType = require('../config/rsqlDataTypeOperators.json');
  var operatorsToUiValues = require('../config/rsqlOperatorToUiValue.json');
  var operatorRelationTypes = require('../config/operatorRelationTypes.json');
  var operatorsToDOWUiValue = require('../config/rsqlOperatorToDOWUiValue.json');
  var getOperatorsByType = _.memoize(function (type) {
    return operatorsByType[type] || operatorsByType['default'];
  });
  function getType(value) {
    if (momentService.isMoment(value)) {
      return 'datetime';
    } else if (_.isNumber(value)) {
      return 'number';
    } else if (_.isArray(value)) {
      return 'multi';
    }
    return (0, _typeof2["default"])(value);
  }
  function operatorToUiValue(operator) {
    return operatorsToUiValues[operator] || operator;
  }
  function operatorToDOWUiValue(operator) {
    return operatorsToDOWUiValue[operator] || operator;
  }
  function getValueTypes(values) {
    return _.reduce(values, function (type, value) {
      return type === getType(value) ? type.toLowerCase() : undefined;
    }, getType(values[0]));
  }
  function getOperatorKey(operator) {
    return operator.toLowerCase().replace(/\s/g, '');
  }
  function getRsqlOperator(operator) {
    var values = Array.prototype.slice.call(arguments, 1);
    var valueTypes = getValueTypes(values);
    return getRsqlOperatorByType(operator, valueTypes);
  }
  function getRsqlOperatorByType(operator, type) {
    var operatorKey = getOperatorKey(operator);
    var operators = getOperatorsByType(type);
    if (operators[operatorKey]) {
      return operators[operatorKey];
    } else {
      throw new Error('operator is not implemented in RSQL: ' + operator + ', operatorKey ' + operatorKey + ', available operators: ' + JSON.stringify(operators));
    }
  }
  function formatOperand(operand, type, skipConditionEscaping) {
    if (momentService.isMoment(operand)) {
      return operand.toISOString();
    }
    if (_.isString(operand)) {
      operand = skipConditionEscaping ? operand : escapeConditionsInsideOperandValue(operand);
      return /\s/g.test(operand) ? '\'' + operand + '\'' : operand;
    }
    if (_.isObject(operand) && _.has(operand, 'value')) {
      return formatOperand(operand.value, type, skipConditionEscaping);
    }
    if (Array.isArray(operand)) {
      return operand.map(function (entry) {
        return formatOperand(entry, type, skipConditionEscaping);
      });
    }
    return operand;
  }
  function escapeConditionsInsideOperandValue(operand) {
    var escapedOperand = operand.replace(' and ', ' %and% ');
    escapedOperand = escapedOperand.replace(' or ', ' %or% ');
    return escapedOperand;
  }
  function isInclusionTypeOperator(operator) {
    return _.includes(operatorRelationTypes.inclusionType, getOperatorKey(operator));
  }
  function isExclusionTypeOperator(operator) {
    return _.includes(operatorRelationTypes.exclusionType, getOperatorKey(operator));
  }
  function isValidOperator(operator) {
    return isInclusionTypeOperator(operator) || isExclusionTypeOperator(operator);
  }
  return {
    getRsqlOperator: getRsqlOperator,
    getRsqlOperatorByType: getRsqlOperatorByType,
    formatOperand: formatOperand,
    operatorToUiValue: operatorToUiValue,
    isInclusionTypeOperator: isInclusionTypeOperator,
    isExclusionTypeOperator: isExclusionTypeOperator,
    isValidOperator: isValidOperator,
    operatorToDOWUiValue: operatorToDOWUiValue
  };
};
RsqlQueryService.$inject = ['MomentService'];
module.exports = RsqlQueryService;